<template>
  <div>
    <ol :start="'1'">
      <li class="f-14 f-Overpass">
        Apakah penjelasan trainer informatif bagi user?
      </li>
    </ol>

    <div class="bintang">
      <star-rating
        :v-model="'rating1'"
        :show-rating="false"
        :star-size="20"
        :padding="30"
        @rating-selected="selectStar1"
        style="width: max-content"
      />
    </div>

    <div class="d-flex-between-center p-x-20 p-t-16">
      <p class="f-12 f-Overpass">Tidak Membantu</p>
      <p class="f-12 f-Overpass">Sangat Membantu</p>
    </div>

    <ol :start="'2'">
      <li class="f-14 f-Overpass">
        Apakah penjelasan trainer sesuai dengan kebutuhan user?
      </li>
    </ol>

    <div class="bintang">
      <star-rating
        :v-model="'rating2'"
        :show-rating="false"
        :star-size="20"
        :padding="30"
        @rating-selected="selectStar2"
        style="width: max-content"
      />
    </div>

    <div class="d-flex-between-center p-x-20 p-t-16">
      <p class="f-12 f-Overpass">Tidak Membantu</p>
      <p class="f-12 f-Overpass">Sangat Membantu</p>
    </div>

    <ol :start="'3'">
      <li class="f-14 f-Overpass">
        Bagaimana menurut Anda atas solusi yang diberikan trainer untuk
        pertanyaan anda?
      </li>
    </ol>

    <div class="p-x-20">
      <textarea
        v-model="ulasan1"
        :name="'ulasan1'"
        :id="'ulasan1'"
        rows="3"
        maxlength="150"
        class="w-100 f-14 f-Overpass textBox"
        placeholder="Masukkan Ulasan Anda"
        :required="true"
      ></textarea>
    </div>

    <ol :start="'4'">
      <li class="f-14 f-Overpass">
        Kritik dan saran Anda terhadap aplikasi kami?
      </li>
    </ol>

    <div class="p-x-20">
      <textarea
        v-model="ulasan2"
        :name="'ulasan1'"
        :id="'ulasan1'"
        rows="3"
        maxlength="150"
        class="w-100 f-14 f-Overpass textBox"
        placeholder="Masukkan Ulasan Anda"
        :required="true"
      ></textarea>
    </div>

    <div class="p-x-20 p-t-16">
      <button
        class="btn btn-long btn-primary"
        :disabled="checkDisable() || checkValidationAPI"
        @click="submitUlasan"
      >
        Submit Ulasan
      </button>
    </div>
  </div>
</template>

<script>
import StarRating from "vue-star-rating";
import { mapActions } from "vuex";
import { moduleName } from "../store/state";
export default {
  name: "QuestionUlasan",
  components: {
    StarRating,
  },
  props: {
    idTraining: "",
  },
  data() {
    return {
      rating1: 0,
      rating2: 0,
      ulasan1: "",
      ulasan2: "",
      data: {},
      checkValidationAPI: false,
    };
  },

  methods: {
    ...mapActions({
      postUlasan: `${moduleName}/postUlasan`,
    }),

    selectStar1: function (rating) {
      this.rating1 = rating;
    },
    selectStar2: function (rating) {
      this.rating2 = rating;
    },

    checkDisable() {
      let rating1 = this.rating1;
      let rating2 = this.rating2;
      let ulasan1 = this.ulasan1;
      let ulasan2 = this.ulasan2;

      if (rating1 != 0 && rating2 != 0 && ulasan1 != "" && ulasan2 != "") {
        return false;
      } else {
        return true;
      }
    },

    async submitUlasan() {
      this.checkValidationAPI = true;
      let idTraining = this.idTraining;

      const data = {
        query: idTraining,
        data: {
          nilai_informatif: this.rating1,
          nilai_kesesuaian: this.rating2,
          solusi: this.ulasan1,
          kritik_saran: this.ulasan2,
        },
      };

      // try {
      await this.postUlasan(data)
        .then((res) => {
          if (!res.data) {
            // agar saat notif , susunannya dari 'terdapat kesalahan'
            this.$toast.error("Mohon Coba Kembali");
            this.$toast.error("Terdapat Kesalahan");
            this.$router.go(-1);
            this.checkValidationAPI = false;
          } else {
            if (res.code == 200) {
              this.checkValidationAPI = true;
              this.$toast.success("Terimakasih atas ulasan anda!");
              this.$toast.success(res.msg);
              this.$router.push({ name: "training.list" });
            }
          }
        })
        .catch((error) => {
          this.checkValidationAPI = false;
          this.$toast.error(error);
          this.$router.go(-1);
        });
    },
  },
};
</script>

<style scoped>
.textBox {
  padding: 10px;
}
.bintang {
  display: flex;
  justify-content: flex-end;
}

@media (min-width: 320px) and (max-width: 374px) {
  .bintang {
    display: flex;
    margin: 20px;
  }
}

@media (min-width: 375px) {
  .bintang {
    display: flex;
    justify-content: center;
    margin-left: 10px;
  }
}
</style>
